import { BoxProps, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { IconFatArrowRight } from "src/components/icons";

export enum EnumReactionArrowIndicator {
    BULLISH = "bullish",
    BEARISH = "bearish",
    NEUTRAL = "neutral",
}

const variantMap: Record<EnumReactionArrowIndicator, { text: string; color: string; transform: string }> = {
    [EnumReactionArrowIndicator.BULLISH]: { text: "label.bullish", color: "green.500", transform: "rotate(270deg)" },
    [EnumReactionArrowIndicator.BEARISH]: { text: "label.bearish", color: "red.500", transform: "rotate(90deg)" },
    [EnumReactionArrowIndicator.NEUTRAL]: { text: "label.neutral", color: "gray.400", transform: "rotate(0deg)" },
};

interface IReactionArrowIndicator extends BoxProps {
    variant: EnumReactionArrowIndicator;
}

export const ReactionArrowIndicator = ({ variant, ...boxProps }: IReactionArrowIndicator) => {
    const { t } = useTranslation("news");

    return (
        <Flex justifyContent="row" gap={1} {...boxProps}>
            <IconFatArrowRight boxSize={3} color={variantMap[variant].color} transform={variantMap[variant].transform} />
            <Text fontSize="lg" fontWeight="semibold">
                {t(variantMap[variant].text)}
            </Text>
        </Flex>
    );
};
